// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27currentColor%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: var(--spacing-sm);
    margin-bottom: var(--spacing-lg);
  }
  .data {
    font-weight: 800;
    color: #767676;
  }
  .label_col {
    margin-right: 10px;
  }
  
  /* .radio-group {
    display: flex;
    gap: var(--spacing-lg);
    align-items: center;
  }
  
  .radio-group input[type="radio"] {
    width: auto;
    margin-right: var(--spacing-xs);
  } */
  .controls-container {
    display: flex;
    align-items: center;
    gap: var(--spacing-xl);
    margin-bottom: var(--spacing-lg);
    padding: var(--spacing-md) var(--spacing-xl);
    background-color: var(--white);
    border-radius: 4px;
    box-shadow: var(--shadow-sm);
  }
  
  /* Radio Group Styling - Updated */
  .radio-group {
    display: flex;
    gap: var(--spacing-lg);
    flex-shrink: 0;
  }
  
  .radio-group label {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    margin: 0;
    cursor: pointer;
    font-weight: 500;
  }
  
  .radio-group input[type="radio"] {
    width: auto;
    margin: 0;
  }
  
  /* Search Field Styling - Updated */
  .search-field {
    position: relative;
    width: 300px;
    flex-shrink: 0;
  }
  
  .search-field input {
    width: 100%;
    padding: var(--spacing-sm) var(--spacing-xl) var(--spacing-sm) var(--spacing-md);
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-size: 0.9rem;
  }
  
  .search-field i {
    position: absolute;
    right: var(--spacing-sm);
    top: 50%;
    transform: translateY(-50%);
    color: var(--secondary-grey);
    pointer-events: none;
  }
  /* .css-113d811-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {
    color: #1976d2;
    top: 5px;
    left: 10px;
  } */
   .site_div label.Mui-focused {
    color: #1976d2;
    top: 5px;
    left: 10px;
   }
  .site_div #demo-simple-select {
    font-size: 14px;
  }
  /* Date Picker Styling - Updated */
  .date-picker {
    flex-shrink: 0;
  }
  
  .date-picker input {
    padding: var(--spacing-sm);
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-size: 0.9rem;
    color: #767676;
    width: 150px;
    cursor: pointer;
  }
  
  /* Remove the old styles */
  .search-container,
  .date-range {
    display: none;
  }
  
  .form-buttons {
    display: flex;
    justify-content: space-between;
    gap: var(--spacing-md);
    margin-top: var(--spacing-xl);
  }
  .tabs-container .tab  {
    /* background-color: var(--primary-yellow); */
    background-color: #959595;
    /* color: var(--primary-grey); */
    color: #fff;
    border: none;
    padding: 7px;
    padding-right: 8px;
    padding-left: 8px;
    font-size: 14px;
    border-radius: 8px;
    margin-right: 10px;
  }
  .site_div label {
    line-height: 0.9em !important;
    font-size: 14px;
  }
  .tab.active {
    /* background-color: var(--primary-grey); */
    /* color: var(--white); */
    background-color: var(--primary-yellow);
    color: var(--primary-grey);
    font-weight: 500;
  } 
  .group_div {
    display: flex;
    justify-content: space-between;
  }
  .floating-label-group {
    position: relative;
    margin-top: var(--spacing-md); /* Add some top margin */
  }
  
  .floating-label-group input {
    width: 100%;
    padding: var(--spacing-sm); /* Adjust padding */
    border: 1px solid var(--border-color);
    border-radius: 4px;
    font-size: 1rem;
    /* Ensure background is not transparent for label overlap */
    background-color: var(--white); 
  }
  
  .floating-label-group label {
    position: absolute;
    left: var(--spacing-md);
    top: 50%;
    transform: translateY(-50%);
    /* color: var(--secondary-grey); */
    color: #767676;
    background-color: var(--white); /* Match input background */
    padding: 0 var(--spacing-xs); /* Padding to "cut" the border */
    transition: all 0.2s ease-out;
    pointer-events: none; /* Allow clicks to pass through to input */
    font-size: 14px;
  }
  
  /* Styles for when the input is focused OR has content */
  .floating-label-group input:focus + label,
  .floating-label-group input:not(:placeholder-shown) + label {
    top: 0; /* Move label to the top */
    transform: translateY(-50%) scale(0.85); /* Move up and shrink */
    color: var(--primary-grey); /* Change color when active */
    font-weight: 500;
  }
  
  /* Optional: Add focus styling to the input itself */
  .floating-label-group input:focus {
    outline: none;
    border-color: var(--primary-yellow); /* Highlight border on focus */
    box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2); 
  }
  
  /* Adjust placeholder color if needed */
  .floating-label-group input::placeholder {
    color: transparent; /* Hide the actual placeholder text */
  }
  .form-group {
    margin-bottom: 0; /* Reset margin if floating group handles it */
  }
  /* .group_div_1 {
    width: 75%;
  } */
  /* Custom Select Styling */
  select {
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 0.7rem center;
    background-size: 1em;
  }
  
  /* Form Validation Styles */
  .form-group.error input,
  .form-group.error select {
    border-color: var(--error-red);
  }
  
  .form-group.error .error-message {
    color: var(--error-red);
    font-size: 0.875rem;
    margin-top: var(--spacing-xs);
  }
  
  /* Success State */
  .form-group.success input,
  .form-group.success select {
    border-color: var(--success-green);
  }

  .main_container {
    border: 1px solid #e7e7e7;
    border-radius: 8px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  .group_div {
    padding-left: 12px;
    padding-right: 12px;
    padding-top: 10px;
    margin-bottom: 0;
  }
  .inp_div {
    padding-left: 12px;
    padding-right: 12px;
    margin-bottom: 0;
  }
  .blue_primary {
    background-color: #0056B3 !important;
    color: #fff !important;
    margin-left: 10px !important;
  }
.yellow_btn {
  background-color: var(--primary-yellow) !important;
  color: var(--primary-grey) !important;
  font-weight: 600 !important;
}
.blue_secondary {
  background-color: #757575 !important;
    
}
.added_card {
  background-color: #e2e2e2;
    border: 1px solid transparent;
    border-radius: 8px;
    padding: 5px;
    margin-bottom: 10px;
    margin-left: 1px;
    margin-right: 1px;
}
.inp_choose {
  height: 1.7375em !important;
    font-size: 14px !important;
}
.inp_search_div .css-28116y-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
  padding: 1.0px 4px 1.0px 5px !important; 
}
.inp_search_div label {
  font-size: 14px !important;
  line-height: 1 !important;
}
.blue_search {
  height: 41px;
    margin-top: 2px;
    margin-left: 5px;
    font-size: 14px;
}


.btnClass {
   
}
.yellow_btn_2 {
  /* background-color: var(--primary-yellow) !important; */
  background-color: #04596e !important;
  /* color: var(--primary-grey) !important; */
  color: white !important;
  font-weight: 600 !important;
  padding: 0 !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
  font-size: 14px !important;
  height: 33px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.yellow_btn_2 i {
  font-size: 14px !important;
}



@media(max-width:768px) {
  .yellow_apply {
    display: flex;
    justify-content: center;
  }
  .yellow_apply .yellow_btn_1 {
    width: 30%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/FuelManagement/AddFuel/AddFuelDetails.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2DAA2D;IAC3D,sBAAsB;IACtB,gCAAgC;EAClC;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;;EAEA;;;;;;;;;KASG;EACH;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,gCAAgC;IAChC,4CAA4C;IAC5C,8BAA8B;IAC9B,kBAAkB;IAClB,4BAA4B;EAC9B;;EAEA,kCAAkC;EAClC;IACE,aAAa;IACb,sBAAsB;IACtB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,SAAS;EACX;;EAEA,mCAAmC;EACnC;IACE,kBAAkB;IAClB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gFAAgF;IAChF,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,wBAAwB;IACxB,QAAQ;IACR,2BAA2B;IAC3B,4BAA4B;IAC5B,oBAAoB;EACtB;EACA;;;;KAIG;GACF;IACC,cAAc;IACd,QAAQ;IACR,UAAU;GACX;EACD;IACE,eAAe;EACjB;EACA,kCAAkC;EAClC;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,eAAe;EACjB;;EAEA,0BAA0B;EAC1B;;IAEE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,6BAA6B;EAC/B;EACA;IACE,6CAA6C;IAC7C,yBAAyB;IACzB,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,6BAA6B;IAC7B,eAAe;EACjB;EACA;IACE,2CAA2C;IAC3C,yBAAyB;IACzB,uCAAuC;IACvC,0BAA0B;IAC1B,gBAAgB;EAClB;EACA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,6BAA6B,EAAE,wBAAwB;EACzD;;EAEA;IACE,WAAW;IACX,0BAA0B,EAAE,mBAAmB;IAC/C,qCAAqC;IACrC,kBAAkB;IAClB,eAAe;IACf,2DAA2D;IAC3D,8BAA8B;EAChC;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;IACvB,QAAQ;IACR,2BAA2B;IAC3B,kCAAkC;IAClC,cAAc;IACd,8BAA8B,EAAE,2BAA2B;IAC3D,4BAA4B,EAAE,gCAAgC;IAC9D,6BAA6B;IAC7B,oBAAoB,EAAE,0CAA0C;IAChE,eAAe;EACjB;;EAEA,wDAAwD;EACxD;;IAEE,MAAM,EAAE,0BAA0B;IAClC,uCAAuC,EAAE,uBAAuB;IAChE,0BAA0B,EAAE,6BAA6B;IACzD,gBAAgB;EAClB;;EAEA,oDAAoD;EACpD;IACE,aAAa;IACb,mCAAmC,EAAE,8BAA8B;IACnE,4CAA4C;EAC9C;;EAEA,uCAAuC;EACvC;IACE,kBAAkB,EAAE,qCAAqC;EAC3D;EACA;IACE,gBAAgB,EAAE,8CAA8C;EAClE;EACA;;KAEG;EACH,0BAA0B;EAC1B;IACE,gBAAgB;IAChB,yDAA2R;IAC3R,4BAA4B;IAC5B,wCAAwC;IACxC,oBAAoB;EACtB;;EAEA,2BAA2B;EAC3B;;IAEE,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA,kBAAkB;EAClB;;IAEE,kCAAkC;EACpC;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,uCAAuC;EACzC;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB;EACA;IACE,oCAAoC;IACpC,sBAAsB;IACtB,4BAA4B;EAC9B;AACF;EACE,kDAAkD;EAClD,qCAAqC;EACrC,2BAA2B;AAC7B;AACA;EACE,oCAAoC;;AAEtC;AACA;EACE,yBAAyB;IACvB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;EACE,2BAA2B;IACzB,0BAA0B;AAC9B;AACA;EACE,uCAAuC;AACzC;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,YAAY;IACV,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;;AAGA;;AAEA;AACA;EACE,wDAAwD;EACxD,oCAAoC;EACpC,2CAA2C;EAC3C,uBAAuB;EACvB,2BAA2B;EAC3B,qBAAqB;EACrB,4BAA4B;EAC5B,6BAA6B;EAC7B,0BAA0B;EAC1B,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;;;AAIA;EACE;IACE,aAAa;IACb,uBAAuB;EACzB;EACA;IACE,UAAU;EACZ;AACF","sourcesContent":[".form-row {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\r\n    gap: var(--spacing-sm);\r\n    margin-bottom: var(--spacing-lg);\r\n  }\r\n  .data {\r\n    font-weight: 800;\r\n    color: #767676;\r\n  }\r\n  .label_col {\r\n    margin-right: 10px;\r\n  }\r\n  \r\n  /* .radio-group {\r\n    display: flex;\r\n    gap: var(--spacing-lg);\r\n    align-items: center;\r\n  }\r\n  \r\n  .radio-group input[type=\"radio\"] {\r\n    width: auto;\r\n    margin-right: var(--spacing-xs);\r\n  } */\r\n  .controls-container {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-xl);\r\n    margin-bottom: var(--spacing-lg);\r\n    padding: var(--spacing-md) var(--spacing-xl);\r\n    background-color: var(--white);\r\n    border-radius: 4px;\r\n    box-shadow: var(--shadow-sm);\r\n  }\r\n  \r\n  /* Radio Group Styling - Updated */\r\n  .radio-group {\r\n    display: flex;\r\n    gap: var(--spacing-lg);\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .radio-group label {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-xs);\r\n    margin: 0;\r\n    cursor: pointer;\r\n    font-weight: 500;\r\n  }\r\n  \r\n  .radio-group input[type=\"radio\"] {\r\n    width: auto;\r\n    margin: 0;\r\n  }\r\n  \r\n  /* Search Field Styling - Updated */\r\n  .search-field {\r\n    position: relative;\r\n    width: 300px;\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .search-field input {\r\n    width: 100%;\r\n    padding: var(--spacing-sm) var(--spacing-xl) var(--spacing-sm) var(--spacing-md);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 4px;\r\n    font-size: 0.9rem;\r\n  }\r\n  \r\n  .search-field i {\r\n    position: absolute;\r\n    right: var(--spacing-sm);\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    color: var(--secondary-grey);\r\n    pointer-events: none;\r\n  }\r\n  /* .css-113d811-MuiFormLabel-root-MuiInputLabel-root.Mui-focused {\r\n    color: #1976d2;\r\n    top: 5px;\r\n    left: 10px;\r\n  } */\r\n   .site_div label.Mui-focused {\r\n    color: #1976d2;\r\n    top: 5px;\r\n    left: 10px;\r\n   }\r\n  .site_div #demo-simple-select {\r\n    font-size: 14px;\r\n  }\r\n  /* Date Picker Styling - Updated */\r\n  .date-picker {\r\n    flex-shrink: 0;\r\n  }\r\n  \r\n  .date-picker input {\r\n    padding: var(--spacing-sm);\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 4px;\r\n    font-size: 0.9rem;\r\n    color: #767676;\r\n    width: 150px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  /* Remove the old styles */\r\n  .search-container,\r\n  .date-range {\r\n    display: none;\r\n  }\r\n  \r\n  .form-buttons {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    gap: var(--spacing-md);\r\n    margin-top: var(--spacing-xl);\r\n  }\r\n  .tabs-container .tab  {\r\n    /* background-color: var(--primary-yellow); */\r\n    background-color: #959595;\r\n    /* color: var(--primary-grey); */\r\n    color: #fff;\r\n    border: none;\r\n    padding: 7px;\r\n    padding-right: 8px;\r\n    padding-left: 8px;\r\n    font-size: 14px;\r\n    border-radius: 8px;\r\n    margin-right: 10px;\r\n  }\r\n  .site_div label {\r\n    line-height: 0.9em !important;\r\n    font-size: 14px;\r\n  }\r\n  .tab.active {\r\n    /* background-color: var(--primary-grey); */\r\n    /* color: var(--white); */\r\n    background-color: var(--primary-yellow);\r\n    color: var(--primary-grey);\r\n    font-weight: 500;\r\n  } \r\n  .group_div {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  .floating-label-group {\r\n    position: relative;\r\n    margin-top: var(--spacing-md); /* Add some top margin */\r\n  }\r\n  \r\n  .floating-label-group input {\r\n    width: 100%;\r\n    padding: var(--spacing-sm); /* Adjust padding */\r\n    border: 1px solid var(--border-color);\r\n    border-radius: 4px;\r\n    font-size: 1rem;\r\n    /* Ensure background is not transparent for label overlap */\r\n    background-color: var(--white); \r\n  }\r\n  \r\n  .floating-label-group label {\r\n    position: absolute;\r\n    left: var(--spacing-md);\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    /* color: var(--secondary-grey); */\r\n    color: #767676;\r\n    background-color: var(--white); /* Match input background */\r\n    padding: 0 var(--spacing-xs); /* Padding to \"cut\" the border */\r\n    transition: all 0.2s ease-out;\r\n    pointer-events: none; /* Allow clicks to pass through to input */\r\n    font-size: 14px;\r\n  }\r\n  \r\n  /* Styles for when the input is focused OR has content */\r\n  .floating-label-group input:focus + label,\r\n  .floating-label-group input:not(:placeholder-shown) + label {\r\n    top: 0; /* Move label to the top */\r\n    transform: translateY(-50%) scale(0.85); /* Move up and shrink */\r\n    color: var(--primary-grey); /* Change color when active */\r\n    font-weight: 500;\r\n  }\r\n  \r\n  /* Optional: Add focus styling to the input itself */\r\n  .floating-label-group input:focus {\r\n    outline: none;\r\n    border-color: var(--primary-yellow); /* Highlight border on focus */\r\n    box-shadow: 0 0 0 2px rgba(255, 215, 0, 0.2); \r\n  }\r\n  \r\n  /* Adjust placeholder color if needed */\r\n  .floating-label-group input::placeholder {\r\n    color: transparent; /* Hide the actual placeholder text */\r\n  }\r\n  .form-group {\r\n    margin-bottom: 0; /* Reset margin if floating group handles it */\r\n  }\r\n  /* .group_div_1 {\r\n    width: 75%;\r\n  } */\r\n  /* Custom Select Styling */\r\n  select {\r\n    appearance: none;\r\n    background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\r\n    background-repeat: no-repeat;\r\n    background-position: right 0.7rem center;\r\n    background-size: 1em;\r\n  }\r\n  \r\n  /* Form Validation Styles */\r\n  .form-group.error input,\r\n  .form-group.error select {\r\n    border-color: var(--error-red);\r\n  }\r\n  \r\n  .form-group.error .error-message {\r\n    color: var(--error-red);\r\n    font-size: 0.875rem;\r\n    margin-top: var(--spacing-xs);\r\n  }\r\n  \r\n  /* Success State */\r\n  .form-group.success input,\r\n  .form-group.success select {\r\n    border-color: var(--success-green);\r\n  }\r\n\r\n  .main_container {\r\n    border: 1px solid #e7e7e7;\r\n    border-radius: 8px;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\r\n  }\r\n  .group_div {\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n    padding-top: 10px;\r\n    margin-bottom: 0;\r\n  }\r\n  .inp_div {\r\n    padding-left: 12px;\r\n    padding-right: 12px;\r\n    margin-bottom: 0;\r\n  }\r\n  .blue_primary {\r\n    background-color: #0056B3 !important;\r\n    color: #fff !important;\r\n    margin-left: 10px !important;\r\n  }\r\n.yellow_btn {\r\n  background-color: var(--primary-yellow) !important;\r\n  color: var(--primary-grey) !important;\r\n  font-weight: 600 !important;\r\n}\r\n.blue_secondary {\r\n  background-color: #757575 !important;\r\n    \r\n}\r\n.added_card {\r\n  background-color: #e2e2e2;\r\n    border: 1px solid transparent;\r\n    border-radius: 8px;\r\n    padding: 5px;\r\n    margin-bottom: 10px;\r\n    margin-left: 1px;\r\n    margin-right: 1px;\r\n}\r\n.inp_choose {\r\n  height: 1.7375em !important;\r\n    font-size: 14px !important;\r\n}\r\n.inp_search_div .css-28116y-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {\r\n  padding: 1.0px 4px 1.0px 5px !important; \r\n}\r\n.inp_search_div label {\r\n  font-size: 14px !important;\r\n  line-height: 1 !important;\r\n}\r\n.blue_search {\r\n  height: 41px;\r\n    margin-top: 2px;\r\n    margin-left: 5px;\r\n    font-size: 14px;\r\n}\r\n\r\n\r\n.btnClass {\r\n   \r\n}\r\n.yellow_btn_2 {\r\n  /* background-color: var(--primary-yellow) !important; */\r\n  background-color: #04596e !important;\r\n  /* color: var(--primary-grey) !important; */\r\n  color: white !important;\r\n  font-weight: 600 !important;\r\n  padding: 0 !important;\r\n  padding-left: 5px !important;\r\n  padding-right: 5px !important;\r\n  font-size: 14px !important;\r\n  height: 33px !important;\r\n  display: flex !important;\r\n  justify-content: center !important;\r\n  align-items: center !important;\r\n}\r\n\r\n.yellow_btn_2 i {\r\n  font-size: 14px !important;\r\n}\r\n\r\n\r\n\r\n@media(max-width:768px) {\r\n  .yellow_apply {\r\n    display: flex;\r\n    justify-content: center;\r\n  }\r\n  .yellow_apply .yellow_btn_1 {\r\n    width: 30%;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
